import { render } from "./MenuTree.vue?vue&type=template&id=b20d02be&scoped=true"
import script from "./MenuTree.vue?vue&type=script&lang=js"
export * from "./MenuTree.vue?vue&type=script&lang=js"

import "./MenuTree.vue?vue&type=style&index=0&id=b20d02be&scoped=true&lang=css"

import exportComponent from "C:\\JavaWorkSpace\\cbzbs-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b20d02be"]])

export default __exports__